<div display="dynamic" placement="bottom-end" ngbDropdown [autoClose]="'outside'" container="body">
  <button id="samp"
          class="btn btn-sm btn-light mt-1 mb-1" ngbDropdownToggle
          ngbTooltip="Send to VO tools"
          placement="left"
          container="body"
          autoClose="outside">
    <i class="fa-light fa-rocket"></i>
  </button>
  <div ngbDropdownMenu class="shadow-lg">
    <div class="px-2">
      <div class="form-check form-control-sm form-check-inline"
           (click)="setSampSelectionType('all-rows')">
        <input id="samp-all-rows" class="form-check-input" type="radio"
               [checked]="sampSelectionType === 'all-rows'">
        <label class="form-check-label">All rows</label>
      </div>
      <div class="form-check form-control-sm form-check-inline me-auto"
           (click)="setSampSelectionType('selected-rows')">
        <input id="samp-selected-rows" class="form-check-input" type="radio"
               [checked]="sampSelectionType === 'selected-rows'"
               [disabled]="!selectedRowsIds?.length">
        <label class="form-check-label">
          <ng-container [ngPlural]="selectedRowsIds?.length">
            <ng-template ngPluralCase="=0">
              Only selected rows
            </ng-template>
            <ng-template ngPluralCase="=1">
              Only {{selectedRowsIds?.length}} selected row
            </ng-template>
            <ng-template ngPluralCase="other">
              Only {{selectedRowsIds?.length}} selected rows
            </ng-template>
          </ng-container>
        </label>
      </div>
    </div>
    <div class="dropdown-divider"></div>
    <div class="px-2">
      <button id="samp-send" class="btn btn-sm btn-light w-100"
              (click)="emitSampExport()"
              [disabled]="isSampFileBeingGenerated">
        Send to VO tools
      </button>
      <div *ngIf="isSampFileBeingGenerated"
           class="form-text">
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        generating VO file ...
      </div>
      <div *ngIf="this.sampError">
        <small class="text-danger"><i class="fa-light fa-triangle-exclamation me-1"></i>{{this.sampError}}</small>
      </div>
    </div>
  </div>
</div>
